import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import "react-perfect-scrollbar/dist/css/styles.css";
import "nprogress/nprogress.css";
import "src/assets/css/prism.css";
import "src/mixins/chartjs";
import React from "react";
import { Provider } from "react-redux";
import { enableES5 } from "immer";
import store from "src/store";
import { SettingsProvider } from "src/contexts/SettingsContext";
import App from "src/App";
import "src/i18n";
import { SideNavProvider } from "./contexts/SideNavContext";
import { SelectedSubAccountProvider } from "./contexts/SelectedSubAccountContext";
import { SelectedGroupProvider } from "./contexts/SelectedGroupContext";
import { FlagProvider } from "@unleash/proxy-client-react";
import { createRoot } from "react-dom/client";
import { PendingRequestsProvider } from "./contexts/PendingRequestsContext";
import userflow from "userflow.js";

userflow.init(process.env.REACT_APP_USERFLOW_TOKEN);

const config = {
    url: `https://${process.env.REACT_APP_UNLEASH_PROXY_URL}`,
    clientKey: `pool-client-app`,
    refreshInterval: 15,
    appName: process.env.REACT_APP_UNLEASH_APP_NAME,
};

enableES5();

const rootContainer = document.getElementById("root");
const root = createRoot(rootContainer);

root.render(
    <Provider store={store}>
        <SettingsProvider>
            <SideNavProvider>
                <SelectedGroupProvider>
                    <SelectedSubAccountProvider>
                        <PendingRequestsProvider>
                            <FlagProvider config={config}>
                                <App />
                            </FlagProvider>
                        </PendingRequestsProvider>
                    </SelectedSubAccountProvider>
                </SelectedGroupProvider>
            </SideNavProvider>
        </SettingsProvider>
    </Provider>
);
